<template>
  <div>
    <v-card
      elevation="1"
      class="card card-mobile"
      flat
      style="margin-left: 3rem; margin-right: 1rem; border-radius: 15px"
    >
      <Breadcrumbs
        :items="breadcrumbs"
        :page_title="editLibraryData.topicName"
      />
      <!-- <v-system-bar height="60px" class="card-header-system-bar">
        <label
          class="ml-5 my-5"
          style="color: #444444; font-size: 20px !important"
          >{{ "Library" }}</label
        >
      </v-system-bar> -->
      <v-row class="mt-5 ml-3">
        <v-col
          cols="12"
          xs="12"
          sm="12"
          md="4"
          lg="2"
          v-for="(item, i) in cardItems"
          :key="i"
        >
          <!-- $router.push('/home/assignment-course/video-list') -->
          <!-- $router.push('/home/library/' + editLibraryData.topicName + '/' + item.name ) -->
          <v-card
            style="border-radius: 16px;"
            height="200"
            @click="
              item.title == $t('video') && $store.getters.showLibraryAction
                ? gotoCourseVideoList()
                : $router.push({
                    path:
                      '/default-content/library/' +
                      editLibraryData.topicName.split('?').join('') +
                      '/' +
                      item.name,
                    query: { topic_name: editLibraryData.topicName }
                  })
            "
          >
            <v-card-text justify="center" align="center" style="height:100%">
              <div class="imgtext"></div>
              <v-img :src="item.image" width="52" class="communityimg"></v-img>
              <p class="text-center mt-5" style="font-size:18px;color:#424242">
                {{ item.title }}
              </p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import enurl from "@/api/environment";
import axios from "axios";
export default {
  components: {},
  data() {
    return {
      url: enurl.apiUrl,
      fullName_: "",
      //sortNumberItems: [],
      //sortNumberItems2: [],
      permissionDialog: false,

      permissionMessage: "",
      message: "",
      editDialog: false,
      successDialog1: false,
      editData: {}
    };
  },
  mounted() {
    console.log("hello1234");
    this.getTopicWithId();
  },
  computed: {
    ...mapGetters(["editLibraryData"]),
    cardItems() {
      return [
        {
          image: require("@/assets/imgs/library_article.svg"),
          title: this.$t("article"),
          name: "Article"
        },
        {
          image: require("@/assets/imgs/library_sound.svg"),
          title: this.$t("sound"),
          name: "Sound"
        },
        {
          image: require("@/assets/imgs/library_video.svg"),
          title: this.$t("video"),
          name: "Video"
        }
      ];
    },
    breadcrumbs() {
      return [
        {
          //image: "house.png"
          sidebar_title: "defaultcontent"
        },
        {
          text: "library",
          href: "/default-content/library"
        },
        {
          text: this.editLibraryData.topicName
        }
      ];
    }
  },
  methods: {
    // gotoCourseVideoList() {
    //   let breadcrumbs_temp = [
    //     {
    //       sidebar_tilte: "home"
    //     },
    //     {
    //       text: "library",
    //       href: "/home/library"
    //     },
    //     {
    //       text: this.editLibraryData.topicName
    //     },
    //     {
    //       text: "video"
    //     }
    //   ];
    //   this.$router.push("/home/assignment-course/video-list");
    //   localStorage.setItem(
    //     "pageTitle_forCourseVideoList",
    //     this.editLibraryData.topicName
    //   );
    //   localStorage.setItem(
    //     "breadcrumbs_forCourseVideoList", breadcrumbs_temp
    //   );
    // },
    ShowAction(v) {
      if (v == "Edit") {
        this.checkTopicEdit();
      }
    },
    async checkTopicEdit() {
      let self = this;
      //  let checkPermission = await self.checkpermission(5);
      // if (checkPermission) {
      self.editDialog = true;
      //    } else {
      //      self.permissionDialog = true;
      //      self.permissionMessage = "You don't have permission to edit Topic.";
    },
    async getTopicWithId() {
      console.log("hello");
      console.log("hello111");
      const res = await axios.get(
        `${this.url}Topic/Topics/` + localStorage.getItem("libraryId")
      );
      this.editData = res.data.data;
      console.log("this.editData", this.editData);
      res.data.data["sortNumberItemLibrary"] = this.sortNumberItems;
      this.$store.commit("saveEditLibrary", res.data.data);
    }
  }
};
</script>
<style scoped lang="css">
.imgtext {
  height: 130px;
  background-color: #a6cc39;
  opacity: 0.1;
  border-radius: 8px;
  position: relative;
  z-index: 0 !important;
}
.communityimg {
  position: absolute;
  top: 40%;
  left: 48%;
  transform: translate(-50%, -48%);
}
.v-image__image {
  z-index: 10 !important;
}
</style>
